export default {
    newProposal: 'New proposal',
    proposals: 'Proposals',
    suggestMsg: `There aren't any proposals here yet!`,
    all: 'All',
    pending: 'Pending',
    active: 'Active',
    canceled: 'Canceled',
    defeated: 'Defeated',
    succeeded: 'Succeeded',
    queued: 'Queued',
    expired: 'Expired',
    executed: 'Executed',
    delegatee: 'Delegatee Address',
    delegate: 'Delegate',
    setDelegatee: 'Set delegatee',
    connectWallet: 'Connect wallet',
    logOut: 'Log out',
    account: 'Account',
    about: 'About',
    address: 'Address',
    createTitle: 'Title',
    targets: 'Targets',
    addTarget: 'Add Target',
    values: 'Values',
    addValue: 'Add Value',
    signatures: 'Signatures',
    addSignature: 'Add Signature',
    calldatas: 'Calldatas',
    addCalldata: 'Add calldata',
    action: 'Action',
    publish: 'Publish',
    voteTitle: 'Cast your vote',
    vote: 'Vote',
    votes: 'Votes',
    seeMore: 'See more',
    information: 'Information',
    author: 'Author',
    id: 'ID',
    startDate: 'Start date',
    endDate: 'End date',
    results: 'Results',
    currentResults: 'Current results',
    queue: 'Queue',
    execute: 'Execute',
    eta: 'Eta',
    downloadReport: 'Download report',
    confirm: 'Confirm',
    confirmVote: 'Confirm vote',
    confirmVoteTip: 'Are you sure you want to vote',
    confirmVoteTip2: 'This action cannot be undone.',
    confirmProposal: 'Confirm proposal',
    cancel: 'Cancel',
    option: 'Option',
    votingPower: 'Your voting power',
    noDelegateeTip: 'Your have not set delegatee',
    votesZeroTip: 'Your votes is zero',
    delegateeNoSelfTip: 'Delegatee is not you self',
    addAction: 'Add action',
    function: 'Function',
    params: 'Params',
    body: 'What is your proposal?',
    Choose: 'Choose...',
    transaction: 'Transaction Details',
    proposalParams: 'Proposed Actions',
    proposalParamsInput: 'Proposal input params',
    proposalParamsSend: 'Proposal send params',
    tokenIds: 'veGYRO ID'
};
